module.exports = function isValidTokenRole(tokenRole) {
  return /^(?:moderator|publisher|subscriber|publisheronly)$/.test(tokenRole);
};
